import { fetchApi, getFetchApiJSONResponse, catchFetchApiError } from 'shared/functions';
import { CreditRatingError } from 'shared/errors';

export const fetchCreditRatingSummaryTab = entityId => {
  const url = `/storefront/issuers/${entityId}/summary/`;

  return fetchApi(url)
    .then(getFetchApiJSONResponse)
    .catch(async response => {
      await response.json().then(({ message, status, error }) => {
        throw new CreditRatingError({ message, status, error });
      });
    });
};
export const fetchCreditReviewSummaryTab = easynumber => {
  const url = `/sig/api/${easynumber}/summary-tab/`;

  return fetchApi(url)
    .then(getFetchApiJSONResponse)
    .then(result => ({ ...result, easyNumber: easynumber }))
    .catch(catchFetchApiError);
};
